import { cn } from "@/lib/utils";

// Yanthra pyramid glyph + MeetIQ360 wordmark lockup.
export const BrandMark = ({ size = "md", showByline = true, className, testid = "brand-mark" }) => {
  const dim = size === "sm" ? 34 : size === "lg" ? 48 : 40;
  const word = size === "sm" ? "text-base" : size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div data-testid={testid} className={cn("flex items-center gap-3", className)}>
      <div
        className="rounded-2xl grid place-items-center shadow-beam shrink-0"
        style={{ width: dim, height: dim, background: "hsl(var(--navy))" }}
      >
        <svg width={dim * 0.55} height={dim * 0.55} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 2 L20 15 H13 Z" fill="hsl(var(--cyan))" />
          <path d="M12 2 L4 15 H11 Z" fill="#ffffff" fillOpacity="0.92" />
          <path d="M9 17 H15 L13.5 22 H10.5 Z" fill="hsl(var(--gold))" />
        </svg>
      </div>
      <div className="leading-none min-w-0">
        <div className={cn("font-heading leading-none tracking-tight", word)}>
          Meet<span style={{ color: "hsl(var(--cyan))" }}>IQ</span>
          <span style={{ color: "hsl(var(--gold))" }}>360</span>
        </div>
        {showByline && <div className="eyebrow mt-1.5 text-[9px] opacity-80">by Yanthra Labs</div>}
      </div>
    </div>
  );
};

export default BrandMark;
